export default "__VITE_ASSET__ba2eeba9__"